import styled from 'styled-components';

export const TextTimeDown = styled.div`
  color: red;
`;
